/**
 * Continue with Email Button
 *
 * Button component that matches the styling of social auth buttons
 * Used in CRO-WEB-178 experiment to show email form on click
 */

import clsx from "clsx";
import { Mail } from "lucide-react";

interface ContinueWithEmailButtonProps {
  onClick: () => void;
  theme?: "light" | "dark";
  isLoading?: boolean;
}

export const ContinueWithEmailButton: React.FC<
  ContinueWithEmailButtonProps
> = ({ onClick, theme = "light", isLoading = false }) => {
  return (
    <button
      onClick={onClick}
      disabled={isLoading}
      className={clsx(
        "flex w-full items-center justify-center space-x-3 rounded-[100px] px-4 py-3 font-body text-sm font-medium transition ease-out disabled:cursor-not-allowed disabled:opacity-50",
        {
          "border border-zinc-300 bg-white text-zinc-800 hover:bg-zinc-50":
            theme === "light",
          "bg-zinc-800 text-white hover:bg-zinc-700": theme === "dark",
        }
      )}
      data-posthog="continue-with-email-button"
    >
      {isLoading ? (
        <div
          className={clsx("h-5 w-5 animate-spin rounded-full border-2", {
            "border-zinc-300": theme === "light",
          })}
        />
      ) : (
        <Mail className="h-5 w-5" />
      )}
      <span>{isLoading ? "Please wait..." : "Continue with Email"}</span>
    </button>
  );
};

export default ContinueWithEmailButton;
